
import { Form,Link, useLoaderData, useNavigate } from "react-router-dom";
import { Select } from "../components/Select";
import { Button } from "../components/Button";
import { useEffect, useState } from "react";
import { _getTicketStatusOptions, addTicketPayment, createPaystackInvoice, deleteServiceTicket, sendPaystackInvoiceNotification, updateServiceTicketStatus } from "../services/api";
import { formatDate, getUserId, getUserPermission } from "../services/helpers";
import { TextField } from "../components/TextField";
import mixpanel from "../services/mixpanel";

export function ServiceDetails(){
	const loaderData  = useLoaderData();
	const serviceTicket = loaderData.service_details;
	const serviceItemsList = serviceTicket.items;
	const vehicleData = loaderData.vehicle_details.vehicle;
	console.log("laoder",serviceTicket);
	const [showDialog, setShowDialog] = useState(false);
	const [showPaymentDialog, setShowPaymentDialog] = useState(false);
	const [showDeleteDialog, setShowDeleteDialog] = useState(false);
	const [showEmailPaystackDialog, setShowEmailPaystackDialog] = useState(false);
	const [customerEmail, setCustomerEmail] = useState('');
	const [customerName, setCustomerName] = useState('');
	// const [currentStatus,setCurrentStatus] = useState(serviceItemsList[0]?.status === "open");
	const [currentStatus,setCurrentStatus] = useState(serviceTicket.service.status);
	const [_statusOptions,_setStatusOptions] = useState(["open"]);
	const navigate = useNavigate();
	const paystack_request_code = serviceTicket.service.paystack_request_code

	function emailInvoice(e){
		e.preventDefault();
		alert("not implemented");
	}

	function emailPaystackInvoice(){
		setCustomerName(vehicleData.customer_name);
		setCustomerEmail(vehicleData.email || '');
		setShowEmailPaystackDialog(true);
	}

	async function sendPaystackInvoiceEmail() {
		const emailData = {
			customer_email: customerEmail,
			customer_name: customerName,
			paystack_link: `https://paystack.shop/pay/${paystack_request_code}`
		};

		try {
			// const response = await createPaystackInvoice(emailData);
			const response = await sendPaystackInvoiceNotification(emailData);
			console.log("response",await response.text());

			if (response) {
				alert('Paystack invoice email sent successfully!');
				setShowEmailPaystackDialog(false);
			} else {
				alert('Failed to send Paystack invoice email');
			}
		} catch (error) {
			console.error('Error sending Paystack invoice email:', error);
			alert('Error sending Paystack invoice email');
		}
	}



	useEffect(()=> {
		mixpanel.identify(getUserId());
		try{
			_getTicketStatusOptions().then((statuses)=>{
				const map = statuses.statuses.map((stat)=>stat.status);
				_setStatusOptions(map);
			});
		} catch(e){

		}
	},[]);


		function deleteTicket(){
			deleteServiceTicket(window.location.pathname.split('/').pop()).then(
				(result)=>{
					alert(result.msg);
					navigate(`/dashboard/members/u/${vehicleData.customer_id}/services`);
					setShowDialog(false);
				}
			)
		}

	function submitTicketPayment(e) {
			e.preventDefault();
			const form = document.getElementById("addTicketPaymentForm");
			const formData = new FormData(form);
			const ticketId = window.location.pathname.split('/').pop();

			const payload = {
				ticket_id: ticketId,
				currency: formData.get("currency"),
				amount: formData.get("amount"),
				payment_method: formData.get("payment_method"),
				payment_date: formData.get("payment_date"),
				reference: formData.get("reference"),
				ticket_type: "service"
			};

			addTicketPayment(payload).then(async(result)=>{
				let message = await result.json();
				alert(message.msg);
				setShowPaymentDialog(false);
			});



			// console.log(JSON.stringify(payload));
			// setShowPaymentDialog(false);
		}



	// function ope
	function showEditPopup(){
		setShowDialog(true);
	}

	function hideEditPopup(){
		setShowDialog(false);
	}

	function updateStatus(){
		hideEditPopup();

		const form = document.getElementById("changeStatusForm");
		const formData = new FormData(form);
		const ticketId = window.location.pathname.split('/').pop();
		const payload = {
			"ticket_id" : ticketId,
			"new_status" : formData.get("status")
		};

		updateServiceTicketStatus(payload)
		.then(async(response)=>{
			const result = await response.json();
			setCurrentStatus(result.new_status);
		}).catch((e)=>{
			console.log('something broke with updateServiceTicketStatus',e);
		});

	}





	return (
		<main id="AddVehicleService">
			<h1>Service Details</h1>
			<Link to={`/dashboard/members/u/${vehicleData.customer_id}/services`}>{vehicleData.customer_name}'s Services</Link>
			<div id="page-detail-card">
				<div id="header-section">
					<div id="middle">
						<p>Status: <span className="capitalize">{currentStatus}</span>
						<a href="#"><small class="blue-text action-text" onClick={showEditPopup}>Edit</small></a>
						</p>
						<h3>{vehicleData.license_plate}</h3>
						<p>{vehicleData.vehicle_name} ({vehicleData.vehicle_year})</p>
						<p>{vehicleData.customer_name}</p>
						<h4>GHS {serviceTicket.service.total_invoice}</h4>
						{/* <Link >Invoice Customer//</Link> */}
					</div>
					<div id="end">
						<p>Date Created: {formatDate(serviceTicket.service.date_created)}</p>
						<p>Date Updated: {formatDate(serviceTicket.service.date_updated)}</p>
							<Link to={`/dashboard/services/add_ticket?ticket_type=service&ticket_id=${serviceTicket.ticket_id}`}>Edit Service Ticket</Link>
							{/* <Link to={`/dashboard/vehicles/${vehicleData.license_plate}/add_service?service_id=${serviceItemsList[0].ticket_id}`}>Edit Service Ticket</Link> */}
							<button className="link" onClick={()=>setShowPaymentDialog(true)}>Record Payment</button>
							<button className="link" onClick={emailPaystackInvoice}>Email PayStack Invoice</button>
							{getUserPermission() === "admin"  && <button className="link red-text"  onClick={()=>{setShowDeleteDialog(true)}}>Delete Service Ticket </button>}
							{/* {canInvoice && <Link to={`/dashboard/services/invoice/${serviceItemsList[0].ticket_id}`}>Generate Invoice</Link>} */}
					</div>
				</div>
				<div id="service-ticket-items">
					<table className="invoice-table">
						<thead>
							<tr>
								<th>Service Item Name</th>
								<th>Quantity</th>
								<th>Unit Price</th>
								<th>Sub Total</th>
							</tr>
						</thead>
						<tbody>
							{
								serviceItemsList.map((element)=>   (
									<tr key={element.item_id}>
										<td>
											{element.item_name}
											<p className="description">{element.description}</p>
										</td>
										<td>{element.units}</td>
										<td>{element.price == null ? "n/a":`${element.currency} ${element.price}`}</td>
										<td>{element.price == null ? "n/a":`${element.currency} ${Number(element.price)*Number(element.units)}`}</td>
									</tr>)
								)
							}

							<tr className="grey-text">
								<td></td>
								<td></td>
								<td>Sub total</td>
								<td>GHS {serviceTicket.service.total_bill}</td>
							</tr>
							{serviceTicket.service.discount_total !== 0 && <tr className="grey-text">
								<td></td>
								<td></td>
								<td>Discount Applied</td>
								<td>GHS {serviceTicket.service.discount_total}</td>
							</tr>}
							<tr>
								<td></td>
								<td></td>
								<td>TOTAL</td>
								<td>GHS {serviceTicket.service.total_invoice}</td>
							</tr>


						</tbody>
					</table>
				</div>
			</div>
			{showDialog && (
				<div className="dialog-overlay">

					<div className="dialog" >
						<Form id="changeStatusForm">
							<div className="dialog-header">
								<h3>Change Status</h3>
							</div>
							<div className="dialog-content">
								<div className="row">
									<div className="col-3">
										<Select
											label="Status"
											options={_statusOptions}
											name="status"
											defaultValue={currentStatus}
											// value={currencyField}
											// onChange={(e) => set(e.target.value)}
										/>

									</div>
								</div>
							</div>
							<div className="dialog-footer">
								<Button onClick={hideEditPopup} color="red" label="Cancel"/>
								<Button onClick={updateStatus} label="Update Status" color="green" />
							</div>
						</Form>
					</div>
				</div>
			)}

			{showDeleteDialog && (
				<div className="dialog-overlay">

					<div className="dialog" >
						<Form id="addServiceItemForm">
							<div className="dialog-header">
								<h3>Are You sure you want to delete the Order Ticket {window.location.pathname.split('/').pop()}</h3>
							</div>
							<div className="dialog-footer">
								<Button onClick={()=>setShowDeleteDialog(false)} label="Cancel" color="green" />
								<Button onClick={deleteTicket} color="red" label="Delete"/>
							</div>
						</Form>
					</div>
				</div>
			)}

			{showPaymentDialog && (
				<div className="dialog-overlay" onClick={()=>setShowPaymentDialog(false)}>

					<div className="dialog" onClick={(e)=>e.stopPropagation()}>
						<Form id="addTicketPaymentForm" onSubmit={submitTicketPayment}>
							<div className="dialog-header">
								<h3>Add Payment for Service</h3>
							</div>
							<div className="dialog-body">

								<div className="row-2">
									<Select
										label="Currency"
										name="currency"
										options={["GHS","USD"]}
									/>

									<TextField
										label="Amount"
										name="amount"
										type={"number"}
									/>
								</div>

								<div className="row-2">
									<Select
										label={"Payment method"}
										name="payment_method"
										options={["Cash","Paystack","Zipbooks"]}
									/>

									<TextField
										label="Payment Date"
										name="payment_date"
										type={"date"}
									/>

								</div>


								<TextField
									label="Reference"
									type={"text"}
									name="reference"
								/>
							</div>
							<div className="dialog-footer">
								<Button onClick={()=>setShowPaymentDialog(null)} color="red" label="Cancel"/>
								<Button type="submit" label="Record Payment" color="green" />
							</div>
						</Form>
					</div>
				</div>
			)}

			{showEmailPaystackDialog && (
				<div className="dialog-overlay">
					<div className="dialog">
						<div className="dialog-header">
							<h3>Email Paystack Invoice</h3>
						</div>
						<div className="dialog-content">
							<div className="row">
								<div className="col">
									<TextField
										label="Customer Name"
										type="text"
										value={customerName}
										onChange={(e) => setCustomerName(e.target.value)}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col">
									<TextField
										label="Customer Email"
										type="email"
										value={customerEmail}
										onChange={(e) => setCustomerEmail(e.target.value)}
									/>
								</div>
							</div>
						</div>
						<div className="row">
									<TextField
										label="Link to invoice"
										type={"text"}
										disabled={true}
										id={"invoice_link"}
										value={`https://paystack.shop/pay/${paystack_request_code}`}

									/>
									<button
										className="link"
										type="button"
										style={{"padding": "4px","margin":"2px"}}
										onClick={(e) => {
											// e.preventDefault();
											const invoiceLink = document.getElementById("invoice_link").value || "";
											if (invoiceLink) {
												navigator.clipboard.writeText(invoiceLink).then(() => {
													alert("Link has been copied to clipboard");
												});
											}
										}}
									>
										Copy link
									</button>
								</div>
						<div className="dialog-footer">
							<Button
								onClick={() => setShowEmailPaystackDialog(false)}
								color="red"
								label="Cancel"
							/>
							<Button
								onClick={sendPaystackInvoiceEmail}
								color="green"
								label="Send Invoice"
							/>
						</div>
					</div>
				</div>
			)}
		</main>
	);
}